module.exports = __webpack_public_path__ + "static/img/mark1-Biamh3q4.7c546e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark1-Biamh3q4.png
// module id = xbis
// module chunks = 16